import { tw } from '@/utils/tw';
import BaseArticleDisclosureLabelTheme from 'base/components/ArticleDisclosureLabel/theme';

const ArticleDisclosureLabel = tw.theme({
  extend: BaseArticleDisclosureLabelTheme,
  base: `bg-logga-300 wings-logga-300 text-logga-700 !font-normal text-body-sm`,
});

export default ArticleDisclosureLabel;
